import React from 'react'
import injectSheet from 'react-jss'
import styles from './sheet.styles'
import Paper from 'pobble-components/dist/paper'

const Sheet = ({ classes, children }) => (
  <Paper className={classes.container}>{children}</Paper>
)

export default injectSheet(styles)(Sheet)
